import { Map } from 'leaflet';
import { useEffect, useState } from 'react';

export const useIsPointVisible = (map: Map, point: [number, number]) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkVisibility = () => {
      if (!isNaN(point[0]) && !isNaN(point[1])) {
        setIsVisible(map.getBounds().contains(point));
      } else {
        setIsVisible(false);
      }
    };
    checkVisibility();

    ['move', 'zoom', 'resize'].forEach(event => {
      map.on(event, checkVisibility);
    });

    return () => {
      ['move', 'zoom', 'resize'].forEach(event => {
        map.off(event, checkVisibility);
      });
    };
  }, [map, point]);

  return isVisible;
};
